import { useState } from "react";
import { Control, useWatch } from "react-hook-form";
import { ModuSignStartDocumentRequest } from "src/api/contract/modusign-types";
import { BaseButton, BaseInput } from "src/components";
import { INVALID_PHONE_NUMBER_MESSAGE, isValidKoreanMobile, onlyNumber } from "src/utils/common-util";

type Props = {
  control: Control<ModuSignStartDocumentRequest>;
  verifyIdx: number;
  onClose: () => void;
  setValueVerification: (verification: { name: string; phoneNumber: string }) => void;
};

const ModuSignPhoneVerify = ({ control, verifyIdx, onClose, setValueVerification }: Props) => {
  const verificationValue = useWatch({
    control,
    name: `document.participantMappingsList.${verifyIdx}.verification.mobileIdentification`,
  });

  const [verification, setVerification] = useState({
    name: verificationValue?.name || "",
    phoneNumber: verificationValue?.phoneNumber || "",
  });

  const [error, setError] = useState({
    nameError: "",
    phoneNumberError: "",
  });

  // 기존 Controller rules를 그대로 옮긴 검증 함수들
  const validateName = (value: string): string => {
    if (!value) {
      return "이름을 입력해주세요.";
    }
    return "";
  };

  const validatePhoneNumber = (value: string): string => {
    if (!value) {
      return "휴대폰 번호를 입력해주세요.";
    }

    // 기존 validate.requried 로직 그대로
    if (!isValidKoreanMobile(String(value))) {
      return INVALID_PHONE_NUMBER_MESSAGE;
    }

    return "";
  };

  // 모든 필드 검증
  const validateAll = (): boolean => {
    const nameError = validateName(verification.name);
    const phoneNumberError = validatePhoneNumber(verification.phoneNumber);

    setError({
      nameError,
      phoneNumberError,
    });

    return !nameError && !phoneNumberError;
  };

  const handleSubmit = () => {
    const isValid = validateAll();
    if (isValid) {
      setValueVerification(verification);
      onClose();
    }
  };
  return (
    <>
      <section className="base-abstract-modal__title">
        <h1>받는 사람의 휴대폰 인증 추가</h1>
      </section>
      <section className="base-abstract-modal__contents mx30">
        <ul className="base-list">
          <li>
            문서 열람 시 받는사람 본인 명의의 휴대폰 인증이 필요합니다.
            <br />
            (타인, 법인 명의의 휴대폰 본인 인증 불가)
          </li>
          <li>받는 사람의 실명 (휴대폰 명의자) 을 입력해 주세요.</li>
        </ul>
        <div className="contents-container mt20">
          <section className="contents-container__grid mb10">
            <div className="contents-container__grid-index">
              <p className="required">이름</p>
            </div>
            <div className="contents-container__grid-contents flex-center-end pl5">
              <BaseInput
                placeholder="이름을 입력해주세요" //
                onChange={(value: string) => {
                  setVerification({ ...verification, name: value });

                  if (error.nameError) {
                    setError((prev) => ({ ...prev, nameError: validateName(value) }));
                  }
                }}
                value={verification.name}
                name={""}
                errorText={error.nameError}
              />
            </div>
          </section>
          <section className="contents-container__grid">
            <div className="contents-container__grid-index">
              <p className="required">휴대폰 번호</p>
            </div>
            <div className="contents-container__grid-contents flex-center-end pl5">
              <BaseInput
                placeholder="숫자만 입력해주세요"
                onChange={(text: string) => {
                  setVerification({ ...verification, phoneNumber: onlyNumber(text) });
                  if (error.phoneNumberError) {
                    setError((prev) => ({ ...prev, phoneNumberError: validatePhoneNumber(onlyNumber(text)) }));
                  }
                }}
                value={verification.phoneNumber}
                name={""}
                errorText={error.phoneNumberError}
              />
            </div>
          </section>
        </div>
      </section>
      <section className="base-abstract-modal__btn-wrap">
        <BaseButton title="닫기" className="color-white" onClick={onClose} />
        <BaseButton title="인증추가" onClick={handleSubmit} />
      </section>
    </>
  );
};

export default ModuSignPhoneVerify;
